




































































































































































































































































































































































































































































































































































































































































































































































































































import "bootstrap-vue";
import Vue from "vue";
import Component from "vue-class-component";
import Multiselect from "vue-multiselect";
import VueElementLoading from "vue-element-loading";
import DatePicker from "vue2-datepicker";
import store from "@/services/store";
import axios from "axios";
import {
    AppDataClass,
    formatAmount,
    IAbp,
    IContractAppDetailResponse,
    IGu,
    IPaymentRow,
    IPpr,
    IPrg,
    IRegion,
    ISpf,
    mapResponseToForm,
    PaymentCompare,
} from "./form-409-types";
import Form409AppCard from "./form-409-app-card.vue";
import { log } from "@amcharts/amcharts4/.internal/core/utils/Log";

@Component({
    name: "EditForm409",
    components: {
        multiselect: Multiselect,
        loading: VueElementLoading,
        "date-picker": DatePicker,
        Form409AppCard,
    },
})
export default class EditForm409 extends Vue {
    $refs!: {
        drop: any;
        [key: string]: any;
    };
    private mode: "view" | "edit" | "create" = "view";
    private showDetailForm: boolean = false;
    private appData: AppDataClass = new AppDataClass();
    private bar: number = 0;
    private loading: boolean = false;
    private isInitialized = false;
    private oblKato: any = null;
    private backList = true;
    private selectedDate: Date = new Date();
    private selectedRegion: IRegion | null = null;
    private selectedAbp: IAbp | null = null;
    private selectedGu: IGu | null = null;
    private selectedPrg: IPrg | null = null;
    private selectedPpr: IPpr | null = null;
    private selectedSpf: ISpf | null = null;
    private selectedDevType: number = 2;
    private showCloseModal: boolean = false;

    private get items(): any {
        return {
            region: this.$t(
                "modules.budget_execution_monitoring.editor_409.filter_params.region"
            ),
            abp: this.$t(
                "modules.budget_execution_monitoring.editor_409.filter_params.abp"
            ),
            gu: this.$t(
                "modules.budget_execution_monitoring.editor_409.filter_params.gu"
            ),
            prg: this.$t(
                "modules.budget_execution_monitoring.editor_409.filter_params.prg"
            ),
            ppr: this.$t(
                "modules.budget_execution_monitoring.editor_409.filter_params.ppr"
            ),
            spf: this.$t(
                "modules.budget_execution_monitoring.editor_409.filter_params.spf"
            ),
        };
    }

    private get developes() {
        return [
            {
                text: this.$t(
                    "modules.budget_execution_monitoring.editor_409.filter_params.prg_type.current"
                ),
                code: 0,
            },
            {
                text: this.$t(
                    "modules.budget_execution_monitoring.editor_409.filter_params.prg_type.develop"
                ),
                code: 1,
            },
            {
                text: this.$t(
                    "modules.budget_execution_monitoring.editor_409.filter_params.prg_type.all"
                ),
                code: 2,
            },
        ];
    }

    private regionList: any[] = [];
    private guList: any[] = [];
    private abpList: any[] = [];
    private prgList: any[] = [];
    private pprList: any[] = [];
    private spfList: any[] = [];
    private contractList: any[] = [];
    private limit = 50;
    private nextCursor: any = null;
    private hasMore = true;
    private observer: IntersectionObserver | null = null;
    private guNameCache: Record<string, string> = {};
    private guNameCacheKk: Record<string, string> = {};
    private expandedContracts: Record<string, boolean> = {};
    private contractApps: Record<string, any[]> = {};
    private isAppSaving: boolean = false;
    private appPayments: IPaymentRow[] = [];
    private nomZaInIisk: boolean = false;
    private appBinding: any = null;
    private validationErrors: any = {};
    private isEdited: boolean = false;
    private originalAppData: AppDataClass = new AppDataClass();

    get userId() {
        return store.getters.user_uuid;
    }

    private get curLanguage() {
        return this.$i18n.locale || "ru";
    }

    public get oblCode(): string {
        return (this.oblKato || "").padStart(2, "0");
    }

    private get developTypeText(): string {
        const found = this.developes.find(
            (d) => d.code === this.selectedDevType
        );
        return String(found?.text ?? "");
    }

    public async mounted() {
        this.$nextTick(() => {
            this.setupObserver();
        });
    }

    private setupObserver() {
        if (this.observer) {
            this.observer.disconnect();
        }

        this.observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    if (
                        !this.isInitialized ||
                        this.loading ||
                        !this.hasMore ||
                        !this.backList
                    )
                        return;
                    this.getContractList();
                }
            },
            { root: null, rootMargin: "200px", threshold: 0 }
        );

        const el = this.$refs.loadMoreTrigger as Element;
        if (el) {
            this.observer.observe(el);
        }
    }

    beforeDestroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    public async created() {
        try {
            this.$watch("selectedDate", async () => {
                if (!this.selectedDate) return;

                // действие параметров на дату платежа проверяется при сохранении
                if (this.skipDateReload) {
                    this.skipDateReload = false;
                    return;
                }
                const prevAbpCode = this.selectedAbp?.abp ?? null;
                const prevGuCode = this.selectedGu?.code ?? null;
                const prevPprCode = this.selectedPpr?.ppr ?? null;
                const prevSpfCode = this.selectedSpf?.spf ?? null;

                if (this.selectedRegion) {
                    await this.loadAbpData(this.selectedRegion);
                    if (prevAbpCode !== null) {
                        this.selectedAbp =
                            this.abpList.find((a) => a.abp === prevAbpCode) ??
                            this.abpList[0] ??
                            null;
                    }
                }

                const tasks: Promise<void>[] = [this.loadSpfData()];
                if (this.selectedAbp) tasks.push(this.loadGuData());
                if (this.selectedAbp && this.selectedPrg)
                    tasks.push(this.loadPprData());
                await Promise.all(tasks);

                if (
                    prevGuCode &&
                    !this.guList.some((g) => g.code === prevGuCode)
                ) {
                    this.selectedGu = null;
                }

                if (
                    prevPprCode !== null &&
                    !this.pprList.some((p) => p.ppr === prevPprCode)
                ) {
                    this.selectedPpr = null;
                } else if (
                    prevSpfCode !== null &&
                    !this.spfList.some((s) => s.spf === prevSpfCode)
                ) {
                    this.selectedSpf = null;
                }
            });
            this.$watch("selectedRegion", (newValue) => {
                this.selectedAbp = null;
                if (!newValue) return;
                this.loadAbpData(newValue);
            });
            this.$watch("selectedAbp", async (newValue) => {
                this.selectedPrg = null;
                this.selectedGu = null;
                if (!newValue) return;
                this.loadGuData();
                this.loadPrgData(newValue);
            });
            this.$watch("selectedPrg", async (newValue) => {
                this.selectedPpr = null;
                if (!newValue) return;
                this.loadPprData();
            });
            this.$watch("selectedPpr", async (newValue) => {
                this.selectedSpf = null;
                if (!newValue) return;
                this.loadSpfData();
            });
            this.$watch("curLanguage", () => {
                this.getContractList();
                this.isInitialized = true;
                this.$nextTick(() => {
                    this.setupObserver();
                });
            });

            await this.fetchObl();
            await this.loadRegion();
            await this.loadAbpData(this.selectedRegion!);
            await this.loadGuData();
            await this.loadSpfData();

            await this.getContractList();
            this.isInitialized = true;
            this.$nextTick(() => {
                this.setupObserver();
            });
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.budget_execution_monitoring.editor_409.messages.init_err_msg"
                        )
                    ),
                    error.message
                );
            }
        }
    }

    private formatDate(date: Date | null): string | null {
        if (!date) return null;

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    }

    private formatDisplayDate(value: string | null | undefined): string {
        if (!value) return "";

        const [year, month, day] = value.slice(0, 10).split("-");

        return `${day}.${month}.${year}`;
    }

    private contractKey(contract: any): string {
        return [
            contract.gu_bin,
            contract.func?.slice(-6),
            contract.espk,
            contract.nom_dog,
            contract.dt_dog,
        ].join("|");
    }

    private getAppsText(count: number): string {
        if (count % 10 === 1 && count % 100 !== 11) {
            return this.curLanguage === "kk"
                ? "өтінім"
                : this.curLanguage === "en"
                ? "application"
                : "заявка";
        }

        if (
            [2, 3, 4].includes(count % 10) &&
            ![12, 13, 14].includes(count % 100)
        ) {
            return this.curLanguage === "kk"
                ? "өтінім"
                : this.curLanguage === "en"
                ? "applications"
                : "заявки";
        }

        return this.curLanguage === "kk"
            ? "өтінімдер"
            : this.curLanguage === "en"
            ? "applications"
            : "заявок";
    }

    private formatNumber(value: number | null | undefined): string {
        if (value === null || value === undefined) {
            return "";
        }

        return new Intl.NumberFormat("ru-RU", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        }).format(value);
    }

    private projectTagText(contract: any): string {
        return [contract.expense_code, contract.bip_code, contract.stage]
            .filter((v) => v)
            .join(" · ");
    }

    private extractSpfCode(code: string) {
        if (!code) return null;
        return code.slice(-3);
    }

    private async changeData() {
        if (!this.selectedDate) {
            this.makeToast(
                "warning",
                String(
                    this.$t(
                        "modules.budget_execution_monitoring.editor_409.messages.sel_date_err_msg"
                    )
                ),
                String(this.$t("modules.common.filter_params"))
            );
            return;
        }
        this.resetPagination();
        await this.getContractList();
        this.$refs.drop.hide(true);
        this.$nextTick(() => {
            this.setupObserver();
        });
    }

    private resetPagination() {
        this.nextCursor = null;
        this.hasMore = true;
        this.contractList = [];
        this.expandedContracts = {};
        this.contractApps = {};
    }

    private resetFilterData() {
        this.selectedDate = new Date();
        this.selectedRegion = this.regionList[0];
        this.selectedAbp = null;
        this.selectedDevType = 2;
    }

    private openFilterByRef(refName: string) {
        const drop = this.$refs.drop;

        if (drop && typeof drop.show === "function") {
            drop.show(true);
        }

        const refItem = this.$refs[refName];

        setTimeout(() => {
            if (!refItem) return;

            if (refItem.$el && typeof refItem.$el.focus === "function") {
                refItem.$el.focus();
            } else if (typeof refItem.focus === "function") {
                refItem.focus();
            }
        }, 100);
    }

    async fetchObl() {
        try {
            await fetch(
                "/api-py/get-budget-obl/" + this.$store.state._instanceCode
            )
                .then((response) => response.json())
                .then((json) => {
                    this.oblKato = json.obl;
                });
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.budget_execution_monitoring.editor_409.messages.load_obl_code_err_msg"
                        )
                    ),
                    error.message
                );
            }
        }
    }

    private async loadRegion() {
        try {
            const response = await fetch(
                "/api-py/get-user-regions-by-obl/" +
                    this.oblCode +
                    "/" +
                    this.userId
            ).then((response) => response.json());
            this.regionList = response.map((item: any) => ({
                ...item,
                text: `${item.code} - ${item.name_ru}`,
                text_kk: `${item.code} - ${item.name_kk}`,
            }));
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.budget_execution_monitoring.editor_409.messages.load_reg_err_msg"
                        )
                    ),
                    error.message
                );
            }
        } finally {
            this.selectedRegion = this.regionList[0];
        }
    }

    private async fetchAbp(regionCode: string): Promise<any[]> {
        try {
            const begDate = this.formatDate(this.selectedDate);
            const endDate = begDate;

            const response = await fetch(
                `/api-py/get-user-abp-by-region-period?uid=${this.userId}&region=${regionCode}&begDate=${begDate}&endDate=${endDate}`
            );
            return await response.json();
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.budget_execution_monitoring.editor_409.messages.load_abp_err_msg"
                        )
                    ),
                    error.toString()
                );
            }
            return [];
        }
    }

    private async loadAbpData(region: IRegion) {
        if (region?.code) {
            const abpList = await this.fetchAbp(region.code);
            this.abpList = abpList
                .map((item: any) => ({
                    ...item,
                    text: `${item.abp} - ${item.name_ru}`,
                    text_kk: `${item.abp} - ${item.name_kk}`,
                }))
                .sort((a, b) => a.abp - b.abp);
            this.selectedAbp = this.abpList[0];
        }
    }

    private async loadGuData() {
        try {
            if (!this.selectedAbp || !this.selectedDate) return;

            const response = await fetch(
                `/api-py/monitoring/reports-constructor/user-gu-access/${
                    this.userId
                }/${this.formatDate(this.selectedDate)}/${
                    this.selectedAbp.abp
                }/${this.selectedRegion?.code}`
            );
            if (response.status === 200) {
                const result = await response.json();
                this.guList = result.map((item: any) => ({
                    ...item,
                    text: `${item.code} - ${item.name_ru}`,
                    text_kk: `${item.code} - ${item.name_kk}`,
                }));
            }
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.budget_execution_monitoring.editor_409.messages.load_gu_err_msg"
                        )
                    ),
                    error.message
                );
            }
        } finally {
            // this.selectedGu = this.guList[0];
        }
    }

    private async getGuByCode(code: string) {
        try {
            const res = await fetch(`/api-py/dict-gu-by-code/${code}`);
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const data = await res.json();
            return data?.[0] ?? null;
        } catch (error) {
            this.makeToast(
                "danger",
                String(
                    this.$t(
                        "modules.budget_execution_monitoring.editor_409.messages.load_gu_name_err_msg"
                    )
                ),
                (error as Error).toString()
            );
            return null;
        }
    }

    private async fetchPrg(abp: IAbp): Promise<any[]> {
        try {
            const response = await fetch(
                `/api-py/actual-prg-by-abp/${abp.abp}`
            );
            const prgData = await response.json();
            return prgData.map((item: any) => ({
                ...item,
                text: `${item.prg} - ${item.name_ru}`,
                text_kk: `${item.prg} - ${item.name_kk}`,
            }));
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.budget_execution_monitoring.editor_409.messages.load_prg_err_msg"
                        )
                    ),
                    error.toString()
                );
            }
            return [];
        }
    }

    private async loadPrgData(abp: any) {
        if (abp) {
            const prgList = await this.fetchPrg(abp);
            this.prgList = prgList;
        }
    }

    private async loadPprData() {
        if (!this.selectedAbp || !this.selectedPrg || !this.selectedDate)
            return;

        try {
            const response = await fetch(
                `/api-py/get_ppr_by_abp_prg/${this.selectedAbp.abp}/${
                    this.selectedPrg.prg
                }/${this.selectedDate.getFullYear()}`
            ).then((response) => response.json());

            if (response.length === 0) {
                this.pprList = [
                    {
                        ppr: 0,
                        name_ru: "Подпрограмма",
                        name_kk: "Кіші бағдарлама",
                        text: "0 - Подпрограмма",
                        text_kk: "0 - Кіші бағдарлама",
                    },
                ];

                this.selectedPpr = this.pprList[0];
            } else {
                this.pprList = response.map((item: any) => ({
                    ...item,
                    text: `${item.ppr} - ${item.name_ru}`,
                    text_kk: `${item.ppr} - ${item.name_kk}`,
                }));

                this.selectedPpr = null;
            }
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.budget_execution_monitoring.editor_409.messages.load_ppr_err_msg"
                        )
                    ),
                    error.message
                );
            }
        }
    }

    private async loadSpfData() {
        if (!this.selectedDate) return;
        try {
            const response = await fetch(
                "/api-py/get-spf-list/" + this.selectedDate.getFullYear()
            );

            if (!response.ok) {
                const text = await response.text();
                throw new Error(`Ошибка ${response.status}: ${text}`);
            }

            const items = await response.json();
            this.spfList = items.list.map((item: any) => ({
                ...item,
                text_kk: `${item.spf} - ${item.name_kk}`,
            }));
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.budget_execution_monitoring.editor_409.messages.load_spf_err_msg"
                        )
                    ),
                    error.message
                );
            }
        }
    }

    private async getContractList() {
        if (this.loading || !this.hasMore) return;

        try {
            this.loading = true;
            this.bar = 0;
            const isFirstPage = !this.nextCursor;

            const queryParams: any = {
                uid: this.userId,
                obl: this.oblCode,

                ...(this.selectedRegion && {
                    region: this.selectedRegion.code,
                }),

                ...(this.selectedAbp && {
                    abp: this.selectedAbp.abp,
                }),

                ...(this.selectedGu && {
                    gu: this.selectedGu.code,
                }),

                ...(this.selectedPrg && {
                    prg: this.selectedPrg.prg,
                }),

                ...(this.selectedPpr && {
                    ppr: this.selectedPpr.ppr,
                }),

                ...(this.selectedSpf && {
                    spf: this.selectedSpf.spf,
                }),

                ...(this.selectedDate && {
                    begin_date: `${this.selectedDate.getFullYear()}-01-01`,
                    end_date: this.formatDate(this.selectedDate),
                }),

                ...(this.selectedDevType !== 2 && {
                    dev_type: this.selectedDevType,
                }),

                limit: this.limit,

                // cursor pagination
                ...(this.nextCursor?.cursor_dt && {
                    cursor_dt: this.nextCursor.cursor_dt,
                }),

                ...(this.nextCursor?.cursor_nom_dog && {
                    cursor_nom_dog: this.nextCursor.cursor_nom_dog,
                }),

                ...(this.nextCursor?.cursor_id && {
                    cursor_id: this.nextCursor.cursor_id,
                }),
            };

            const response = await axios.get(`api-py/get-409-form-list`, {
                params: queryParams,
            });

            const dogData = response.data.data ?? [];

            this.nextCursor = response.data.next_cursor;
            this.hasMore = response.data.has_next;

            // ---------------- GUNAME CACHE ----------------

            const uniqueGuCodes: string[] = Array.from(
                new Set(
                    dogData
                        .map((item: any) => item.gu)
                        .filter((gu: any) => gu && !this.guNameCache[gu])
                )
            );

            if (uniqueGuCodes.length) {
                await Promise.all(
                    uniqueGuCodes.map(async (code) => {
                        const guData = await this.getGuByCode(code);
                        if (guData) {
                            this.guNameCache[
                                code
                            ] = `${guData.code} - ${guData.name_ru}`;
                            this.guNameCacheKk[code] = `${guData.code} - ${
                                guData.name_kk ?? guData.name_ru
                            }`;
                        }
                    })
                );
            }

            const dogList = dogData.map((item: any) => {
                return {
                    ...item,
                    guName: this.guNameCache[item.gu] ?? item.gu,
                    guName_kk: this.guNameCacheKk[item.gu] ?? item.gu,
                };
            });

            if (isFirstPage) {
                this.contractList = dogList;
            } else {
                this.contractList.push(...dogList);
            }

            this.bar = 100;
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.budget_execution_monitoring.editor_409.messages.load_contract_list_err_msg"
                        )
                    ),
                    error.message
                );
            }
        } finally {
            this.loading = false;
        }
    }

    private async loadApps(contract: any) {
        try {
            const response = await axios.get(
                `/api-py/get-form-409-apps-by-nom-dog`,
                {
                    params: {
                        nom_dog: contract.nom_dog,
                        begin_date: `${this.selectedDate.getFullYear()}-01-01`,
                        end_date: this.formatDate(this.selectedDate),
                        gu_bin: contract.gu_bin,
                        prg: contract.prg,
                        ppr: contract.ppr,
                        spf: contract.espk
                            ? contract.espk.slice(-3)
                            : undefined,
                        dt_dog: contract.dt_dog,
                    },
                }
            );
            this.$set(
                this.contractApps,
                this.contractKey(contract),
                response.data.data || []
            );
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.budget_execution_monitoring.editor_409.messages.load_app_list_err_msg"
                        )
                    ),
                    error.message
                );
            }
        } finally {
        }
    }

    private async toggleApps(contract: any) {
        const nomDog = this.contractKey(contract);
        const isExpanded = this.expandedContracts[nomDog];

        if (isExpanded) {
            this.$set(this.expandedContracts, nomDog, false);
            return;
        }

        if (!this.contractApps[nomDog]) {
            await this.loadApps(contract);
        }

        this.$set(this.expandedContracts, nomDog, true);
    }

    private async openAppCard(nomZa: string) {
        if (this.observer) {
            this.observer.disconnect();
        }
        this.mode = "edit";
        this.appData = new AppDataClass();
        this.appPayments = [];
        this.validationErrors = {};
        this.backList = false;
        this.loading = true;
        await this.getDetailAppInfo(nomZa);

        if (!this.selectedGu && this.appData.gu) {
            this.selectedGu = await this.getGuByCode(this.appData.gu);
        }

        this.originalAppData = JSON.parse(JSON.stringify(this.appData));
        this.showDetailForm = true;
        this.loading = false;
    }

    private createNewData() {
        if (
            !this.selectedRegion ||
            !this.selectedAbp ||
            !this.selectedGu ||
            !this.selectedPrg ||
            !this.selectedPpr
        ) {
            this.makeToast(
                "warning",
                String(
                    this.$t(
                        "modules.budget_execution_monitoring.editor_409.messages.open_new_form_err_msg"
                    )
                ),
                String(
                    this.$t(
                        "modules.budget_execution_monitoring.editor_409.messages.sel_filter_params_err_msg"
                    )
                )
            );
            return;
        }
        if (this.observer) {
            this.observer.disconnect();
        }

        this.resetAppForm();
        this.appPayments = [];
        this.originalAppData = new AppDataClass();
        this.originalAppPayments = [];
        this.nomZaInIisk = false;
        this.appBinding = null;
        this.mode = "create";
        this.showDetailForm = true;
        this.backList = false;
    }

    private async backToContractList() {
        this.justSaved = false;
        this.showDetailForm = false;
        this.backList = true;
        this.resetAppForm();
        this.originalAppData = new AppDataClass();
        this.originalAppPayments = [];
        this.resetPagination();
        this.isEdited = false;
        this.validationErrors = {};
        this.showCloseModal = false;
        await this.getContractList();
        this.$nextTick(() => {
            this.setupObserver();
        });
    }

    private isHeaderChanged(): boolean {
        const a = this.appData;
        const b = this.originalAppData;

        const dateRegA = a.dateReg ? new Date(a.dateReg).getTime() : null;
        const dateRegB = b.dateReg ? new Date(b.dateReg).getTime() : null;

        const dateContractA = a.dateContract
            ? new Date(a.dateContract).getTime()
            : null;
        const dateContractB = b.dateContract
            ? new Date(b.dateContract).getTime()
            : null;

        return (
            a.numApp !== b.numApp ||
            a.numContract !== b.numContract ||
            a.obligationAmount !== b.obligationAmount ||
            a.supplier !== b.supplier ||
            a.description !== b.description ||
            a.numNotify !== b.numNotify ||
            a.binSupplier !== b.binSupplier ||
            a.spf !== b.spf ||
            dateRegA !== dateRegB ||
            dateContractA !== dateContractB
        );
    }

    private isPaymentsChanged(): boolean {
        const appCard = this.$refs.appCard as any;
        const current = appCard?.payments || [];

        const normalize = (p: any): PaymentCompare => ({
            id: p.dbId ?? p.id,
            payDate: p.payDate ? new Date(p.payDate).getTime() : null,
            payAmount: Number(p.payAmount ?? 0),
            invoiceNum: (p.invoiceNum ?? "").trim(),
            source: p.source,
        });

        const a = current.map(normalize);
        const b = this.originalAppPayments.map(normalize);

        if (a.length !== b.length) return true;

        const mapB = new Map(b.map((x) => [x.id, x]));

        return a.some((aItem: PaymentCompare) => {
            const bItem = mapB.get(aItem.id);

            if (!bItem) return true;

            return (
                aItem.payDate !== bItem.payDate ||
                aItem.payAmount !== bItem.payAmount ||
                aItem.invoiceNum !== bItem.invoiceNum ||
                aItem.source !== bItem.source
            );
        });
    }

    private checkIfEdited(): boolean {
        const headerChanged = this.isHeaderChanged();
        const paymentsChanged = this.isPaymentsChanged();

        this.isEdited = headerChanged || paymentsChanged;

        return this.isEdited;
    }

    private originalAppPayments: IPaymentRow[] = [];

    private openCloseModal() {
        if (this.justSaved) {
            this.justSaved = false;
            this.backToContractList();
            return;
        }

        const edited = this.checkIfEdited();
        if (
            edited &&
            (this.mode === "edit" ||
                (!this.isAppSaving && this.mode === "create"))
        ) {
            this.showCloseModal = true;
        } else {
            this.backToContractList();
        }
    }

    private async getDetailAppInfo(nomZa: string) {
        try {
            const response = await axios.get(
                "/api-py/get-409-form-app-detail",
                {
                    params: {
                        nom_za: nomZa,
                        begin_date: `${this.selectedDate.getFullYear()}-01-01`,
                        end_date: `${this.selectedDate.getFullYear()}-12-31`,
                        ...(this.selectedPrg && { prg: this.selectedPrg.prg }),
                        ...(this.selectedPpr && { ppr: this.selectedPpr.ppr }),
                        ...(this.selectedSpf && { spf: this.selectedSpf.spf }),
                    },
                }
            );

            const rows: IContractAppDetailResponse[] = response.data.data ?? [];
            if (rows.length === 0) return;

            this.appData = mapResponseToForm(rows[0]);
            this.originalAppData = JSON.parse(JSON.stringify(this.appData));

            this.nomZaInIisk = response.data.nom_za_in_iisk ?? false;
            this.appBinding = response.data.binding ?? null;

            this.appPayments = rows.map((row) => {
                const appCard = this.$refs.appCard as any;
                const parsedInvoice = appCard.parseInvoice(row);
                return {
                    id: Date.now() + Math.random(),
                    dbId: row.id,
                    payDate: row.pay_date ? new Date(row.pay_date) : null,
                    payAmount: row.pay_amount ?? null,
                    source: row.source,
                    formattedPayAmount: formatAmount(row.pay_amount),
                    isReturnInvoice: parsedInvoice.isReturnInvoice,
                    invoiceNumSuffix: parsedInvoice.invoiceNumSuffix,
                    invoiceNum: parsedInvoice.invoiceNum,
                    invnumLocked: row.invnum_locked ?? false,
                };
            });
            this.originalAppPayments = JSON.parse(
                JSON.stringify(this.appPayments)
            );
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.budget_execution_monitoring.editor_409.messages.load_app_detail_err_msg"
                        )
                    ),
                    error.message
                );
            }
        }
    }

    handleValidationComplete(errors: any) {
        this.validationErrors = errors;
    }

    private validatePositiveSum(fieldKey: string, fieldName: string) {
        const fieldValue = eval(`this.${fieldKey}`);

        if (fieldValue && fieldValue < 0) {
            this.validationErrors[fieldKey] = true;
            this.makeToast(
                "danger",
                String(
                    this.$t(
                        "modules.budget_execution_monitoring.editor_409.messages.enter_positive_value_err_msg",
                        { f: fieldName }
                    )
                ),
                String(
                    this.$t(
                        "modules.budget_execution_monitoring.editor_409.messages.saving_err_msg"
                    )
                )
            );
            return false;
        }
    }

    private containsInvalidChars(value: any): boolean {
        const INVALID_CONTROL_CHARS = /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/;
        return typeof value === "string" && INVALID_CONTROL_CHARS.test(value);
    }

    private validateFieldLength(
        fieldKey: string,
        maxLength: number,
        fieldName: string
    ) {
        const fieldValue = eval(`this.${fieldKey}`);
        const textLength = Array.from(fieldValue).length;

        if (textLength > maxLength) {
            this.validationErrors[fieldKey] = true;
            this.makeToast(
                "warning",
                String(
                    this.$t(
                        "modules.budget_execution_monitoring.editor_409.messages.limit_symbols_err_msg",
                        { f: fieldName, l: maxLength }
                    )
                ),
                String(
                    this.$t(
                        "modules.budget_execution_monitoring.editor_409.messages.validate_error"
                    )
                )
            );
            return false;
        }
        return true;
    }

    private validateCountSymbols(
        fieldKey: string,
        length: number,
        fieldName: string
    ) {
        const fieldValue = eval(`this.${fieldKey}`);
        const textLength = Array.from(fieldValue).length;
        if (textLength !== length) {
            this.validationErrors[fieldKey] = true;
            this.makeToast(
                "warning",
                String(
                    this.$t(
                        "modules.budget_execution_monitoring.editor_409.messages.limit_digit_err_msg",
                        { f: fieldName, l: length }
                    )
                ),
                String(
                    this.$t(
                        "modules.budget_execution_monitoring.editor_409.messages.validate_error"
                    )
                )
            );
            return false;
        }
        return true;
    }

    private validateForm() {
        this.validationErrors = {};

        const isLengthValid = this.validateFields();

        if (!isLengthValid) {
            return false;
        }

        const cf = "modules.budget_execution_monitoring.editor_409.card_fields";
        const fp =
            "modules.budget_execution_monitoring.editor_409.filter_params";
        const baseFields = [
            {
                key: "appData.numContract",
                message: String(this.$t(`${cf}.nom_dog`)),
            },
            {
                key: "appData.binSupplier",
                message: String(this.$t(`${cf}.bin_supp`)),
            },
            {
                key: "appData.supplier",
                message: String(this.$t(`${cf}.supplier`)),
            },
            {
                key: "appData.numNotify",
                message: String(this.$t(`${cf}.num_notify`)),
            },
            {
                key: "appData.dateContract",
                message: String(this.$t(`${cf}.dog_date`)),
            },
            {
                key: "appData.dateReg",
                message: String(this.$t(`${cf}.extra_agree_date`)),
            },
            {
                key: "appData.description",
                message: String(this.$t(`${cf}.desc`)),
            },
        ];

        const fieldsToValidate = baseFields.filter((field) => {
            if (this.mode !== "edit") return true;

            return ![
                "appData.nom_dog",
                "appData.nom_za",
                "appData.summa_dog",
                "appData.pay_amount",
            ].includes(field.key);
        });

        for (const field of fieldsToValidate) {
            const value = eval(`this.${field.key}`);

            if (typeof value === "string" && this.containsInvalidChars(value)) {
                this.validationErrors[field.key] = true;
                this.makeToast(
                    "warning",
                    String(
                        this.$t(
                            "modules.budget_execution_monitoring.editor_409.messages.invalid_symbols_err_msg",
                            { f: field.message }
                        )
                    ),
                    String(
                        this.$t(
                            "modules.budget_execution_monitoring.editor_409.messages.validate_error"
                        )
                    )
                );
                continue;
            }

            // подпрограмма 000 допустима
            const isZeroPpr =
                field.key.endsWith("ppr?.ppr") || field.key === "appData.ppr"
                    ? Number(value) === 0 && value !== "" && value !== null
                    : false;

            if (
                !isZeroPpr &&
                (!value || (typeof value === "string" && value.trim() === ""))
            ) {
                this.validationErrors[field.key] = true;
                this.makeToast(
                    "warning",
                    String(
                        this.$t(
                            "modules.budget_execution_monitoring.editor_409.messages.require_fields_err_msg",
                            { f: field.message }
                        )
                    ),
                    String(
                        this.$t(
                            "modules.budget_execution_monitoring.editor_409.messages.validate_error"
                        )
                    )
                );
            } else {
                this.validationErrors[field.key] = false;
            }
        }

        const appCard = this.$refs.appCard as any;
        const payments: any[] = appCard?.payments ?? [];
        const totalPayAmount =
            Math.round(
                payments.reduce(
                    (sum: number, p: any) => sum + Number(p.payAmount ?? 0),
                    0
                ) * 100
            ) / 100;

        if (
            Math.round(this.appData.obligationAmount * 100) / 100 <
            totalPayAmount
        ) {
            this.validationErrors["appData.obligationAmount"] = true;
            this.makeToast(
                "warning",
                this.$t(
                    "modules.budget_execution_monitoring.editor_409.messages.conflict_sum_dog_sum_payment"
                ),
                `${this.$t(
                    "modules.budget_execution_monitoring.editor_409.messages.validate_error"
                )}`
            );
        }

        if (this.appData?.dateContract && this.appData?.dateReg) {
            const contract = new Date(this.appData.dateContract);
            const reg = new Date(this.appData.dateReg);

            contract.setHours(0, 0, 0, 0);
            reg.setHours(0, 0, 0, 0);

            if (reg < contract) {
                this.validationErrors["appData.dateReg"] = true;
                this.makeToast(
                    "warning",
                    this.$t(
                        "modules.budget_execution_monitoring.editor_409.messages.conflict_dt_reg_dt_dog"
                    ),
                    `${this.$t(
                        "modules.budget_execution_monitoring.editor_409.messages.validate_error"
                    )}`
                );
            }
        }

        if (!appCard?.isNumAppValid?.()) {
            this.validationErrors["appData.numApp"] = true;
            this.$set(this.validationErrors, "appData.numApp", true);

            this.makeToast(
                "warning",
                this.$t(
                    "modules.budget_execution_monitoring.editor_409.messages.empty_nom_za_err_msg"
                ),
                `${this.$t(
                    "modules.budget_execution_monitoring.editor_409.messages.validate_error"
                )}`
            );
        }

        return Object.keys(this.validationErrors).every(
            (key) => !this.validationErrors[key]
        );
    }

    private validateFields(): boolean {
        const base =
            "modules.budget_execution_monitoring.editor_409.card_fields";
        const validations = [
            this.validatePositiveSum(
                "appData.obligationAmount",
                String(this.$t(`${base}.sum_obligations`))
            ),
            this.validateFieldLength(
                "appData.numContract",
                100,
                String(this.$t(`${base}.nom_dog`))
            ),
            this.validateCountSymbols(
                "appData.numNotify",
                7,
                String(this.$t(`${base}.num_notify`))
            ),
            this.validateCountSymbols(
                "appData.binSupplier",
                12,
                String(this.$t(`${base}.bin_supp`))
            ),
        ];

        return !validations.includes(false);
    }

    private justSaved: boolean = false;

    private handleSaveError(code: string, params: any, message?: string) {
        const base = "modules.budget_execution_monitoring.editor_409.messages";
        const knownCodes = [
            "DUPLICATE_INVNUM",
            "NOM_DOG_CONFLICT",
            "SUMMA_DOG_CONFLICT",
            "RNN_SUPPLIER_CONFLICT",
            "NOM_UVED_MISMATCH_FOR_NOM_ZA",
            "NOM_ZA_MISMATCH_FOR_NOM_UVED",
            "DT_DOG_MISMATCH_FOR_NOM_ZA",
            "DT_REG_MISMATCH_FOR_NOM_ZA",
            "DUPLICATE_EMPTY_INVNUM_FOR_NOM_ZA",
            "REQUIRED_PARAM_MISSING",
            "PAY_DATE_AFTER_CLOSE",
            "BOUND_FIELD_LOCKED",
            "DUPLICATE_INVNUM_IISK",
            "LAST_PAYMENT_IN_YEAR",
            "ROW_NOT_FOUND",
            "FORBIDDEN_ROW",
            "KEY_FIELD_LOCKED",
        ];

        if (code === "VALIDATION_ERROR") {
            this.handleValidationError(params);
            return;
        }

        const rawParams = params;

        if (code === "REQUIRED_PARAM_MISSING") {
            params = {
                f: String(
                    this.$t(
                        `modules.budget_execution_monitoring.editor_409.filter_params.${params?.param}`
                    )
                ),
            };
        } else if (code === "KEY_FIELD_LOCKED") {
            params = {
                f: String(
                    this.$t(
                        `modules.budget_execution_monitoring.editor_409.filter_params.${params?.field}`
                    )
                ),
            };
        } else if (code === "BOUND_FIELD_LOCKED") {
            const fieldNames: { [f: string]: string } = {
                nom_dog: "nom_dog",
                dt_dog: "dog_date",
                dt_reg_year: "extra_agree_date",
            };
            params = {
                p: params?.project,
                f: String(
                    this.$t(
                        `modules.budget_execution_monitoring.editor_409.card_fields.${
                            fieldNames[params?.field]
                        }`
                    )
                ),
            };
        } else if (code === "PAY_DATE_AFTER_CLOSE") {
            params = {
                n: params?.n,
                entity: String(
                    this.$t(`${base}.pay_date_entity_${params?.entity}`)
                ),
            };
        }

        const text = knownCodes.includes(code)
            ? String(this.$t(`${base}.${code}`, params))
            : message || String(this.$t(`${base}.unknown_err_msg`));

        this.makeToast(
            "danger",
            text,
            String(this.$t(`${base}.saving_err_msg`))
        );

        this.highlightParamError(code, rawParams, text);
    }

    private handleValidationError(params: any) {
        const base = "modules.budget_execution_monitoring.editor_409.messages";
        const cf = "modules.budget_execution_monitoring.editor_409.card_fields";
        const labelKeys: { [f: string]: string } = {
            nom_za: "nom_za",
            nom_dog: "nom_dog",
            rnn_supplier: "bin_supp",
            supplier: "supplier",
            nom_uved: "num_notify",
            item_description: "desc",
            dt_dog: "dog_date",
            dt_reg: "extra_agree_date",
            summa_dog: "sum_obligations",
        };
        const fieldKeys: { [f: string]: string } = {
            nom_za: "appData.numApp",
            nom_dog: "appData.numContract",
            rnn_supplier: "appData.binSupplier",
            supplier: "appData.supplier",
            nom_uved: "appData.numNotify",
            item_description: "appData.description",
            dt_dog: "appData.dateContract",
            dt_reg: "appData.dateReg",
            summa_dog: "appData.obligationAmount",
        };
        const rowFields: { [rule: string]: string } = {
            fill_pay_date_in_row: "payDate",
            pay_date_reg_date_err_msg: "payDate",
            pay_year_reg_year_err_msg: "payDate",
            fill_sum_pay_in_row: "payAmount",
            sum_refund_err_ng_msg: "payAmount",
            sum_refund_err_ps_msg: "payAmount",
            fill_invoice_err_msg: "invoiceNum",
            limit_cnt_symb_invoice_err_msg: "invoiceNum",
            invalid_symbol_invoice_err_msg: "invoiceNum",
        };

        const field: string = params?.field ?? "";
        const label = labelKeys[field]
            ? String(this.$t(`${cf}.${labelKeys[field]}`))
            : field;
        const text = String(
            this.$t(`${base}.${params?.rule}`, {
                f: label,
                l: params?.l,
                n: params?.n,
            })
        );

        this.makeToast(
            "danger",
            text,
            String(this.$t(`${base}.saving_err_msg`))
        );

        if (fieldKeys[field]) {
            this.$set(this.validationErrors, fieldKeys[field], true);
        }
        if (params?.n && rowFields[params?.rule]) {
            (this.$refs.appCard as any)?.markRowError?.(
                params.n,
                rowFields[params.rule],
                text
            );
        }
    }


    private highlightParamError(code: string, params: any, text: string) {
        if (
            (code === "DUPLICATE_INVNUM" ||
                code === "DUPLICATE_EMPTY_INVNUM_FOR_NOM_ZA" ||
                code === "DUPLICATE_INVNUM_IISK") &&
            params?.n
        ) {
            (this.$refs.appCard as any)?.markInvoiceError?.(params?.n, text);
            return;
        }

        if (code === "BOUND_FIELD_LOCKED") {
            const lockedKeys: { [f: string]: string } = {
                nom_dog: "appData.numContract",
                dt_dog: "appData.dateContract",
                dt_reg_year: "appData.dateReg",
            };
            const lockedKey = lockedKeys[params?.field];
            if (lockedKey) this.$set(this.validationErrors, lockedKey, true);
            return;
        }

        if (
            code !== "REQUIRED_PARAM_MISSING" &&
            code !== "PAY_DATE_AFTER_CLOSE"
        )
            return;

        if (code === "PAY_DATE_AFTER_CLOSE") {
            (this.$refs.appCard as any)?.markPayDateError?.(params?.n, text);
        }

        const isEdit = this.mode === "edit";
        const keys: { [param: string]: string } = {
            region: isEdit ? "appData.budgetRegion" : "selectedRegion?.code",
            abp: isEdit ? "appData.abp" : "selectedAbp?.abp",
            gu: isEdit ? "appData.gu" : "selectedGu?.code",
            prg: isEdit ? "appData.prg" : "selectedPrg?.prg",
            ppr: isEdit ? "appData.ppr" : "selectedPpr?.ppr",
            spf: isEdit ? "appData.spf" : "selectedSpf?.spf",
        };
        const key = keys[params?.param ?? params?.entity];
        if (key) this.$set(this.validationErrors, key, true);
    }

    private async saveNewApp(): Promise<boolean> {
        const appCard = this.$refs.appCard as any;

        if (!this.validateForm()) return false;

        const isPaymentsValid = appCard.validatePaymentList?.();
        if (!isPaymentsValid) return false;

        const isExistPayment = appCard.isExistPaymentList?.();
        if (!isExistPayment) return false;

        this.isAppSaving = true;

        try {
            const headerChanged = this.isHeaderChanged();
            const formData = appCard.getFormData(headerChanged);
            if (!formData) return false;
          
            formData.original_nom_za =
                this.mode === "edit" ? this.originalAppData?.numApp || null : null;

            const check = await axios.post(
                "/api-py/check-form-409-pay-dates",
                formData
            );
            if (check.data.status === "error") {
                this.justSaved = false;
                this.handleSaveError(
                    check.data.code,
                    check.data.params,
                    check.data.message
                );
                return false;
            }

            const response = await axios.post(
                "/api-py/save-form-409-edit-data",
                formData
            );

            const { status, code, params, message } = response.data;

            if (status === "error") {
                this.justSaved = false;
                this.handleSaveError(code, params, message);
                return false;
            }

            if (status !== "success") {
                this.justSaved = false;
                this.makeToast(
                    "danger",
                    this.$t(
                        "modules.budget_execution_monitoring.editor_409.messages.saving_err_msg"
                    ),
                    `${this.$t(
                        "modules.budget_execution_monitoring.editor_409.messages.saving_msg"
                    )}`
                );
                return false;
            }

            this.$emit("messageSent", { nom_za: this.appData.numApp });

            this.makeToast(
                "success",
                this.$t(
                    "modules.budget_execution_monitoring.editor_409.messages.success_saved_msg"
                ),
                `${this.$t(
                    "modules.budget_execution_monitoring.editor_409.messages.saving_msg"
                )}`
            );

            this.mode = "edit";
            this.isEdited = false;
            this.justSaved = true;

            await this.getDetailAppInfo(this.appData.numApp);

            return true;
        } catch (error) {
            this.justSaved = false;
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    this.$t(
                        "modules.budget_execution_monitoring.editor_409.messages.saving_err_msg"
                    ),
                    error.message
                );
            }

            return false;
        } finally {
            this.isAppSaving = false;
        }
    }

    private async handleRemoveAll() {
        const prg = String(this.appData.prg ?? "").padStart(3, "0");
        const ppr = String(this.appData.ppr ?? "").padStart(3, "0");
        const spfCode = this.appData.spf ?? "";
        const espk = String(spfCode).padStart(6, "0");
        const gu_bin = this.appData.gu_bin;
        const nom_dog = this.appData.numContract;
        const nom_za = this.appData.numApp;

        try {
            this.isAppSaving = true;
            const response = await axios.delete(
                "/api-py/delete-form-409-edit-contract",
                {
                    params: { nom_dog, nom_za, gu_bin, prg, ppr, espk },
                }
            );

            if (response.data.code === "LAST_PAYMENT_IN_YEAR") {
                this.handleSaveError(response.data.code, response.data.params);
                return;
            }

            if (response.data.status !== "success") {
                throw new Error(
                    response.data.message ||
                        `${this.$t(
                            "modules.budget_execution_monitoring.editor_409.messages.unknown_err_msg"
                        )}`
                );
            }

            this.makeToast(
                "success",
                this.$t(
                    "modules.budget_execution_monitoring.editor_409.messages.success_saved_msg"
                ),
                `${this.$t(
                    "modules.budget_execution_monitoring.editor_409.messages.deleting_msg"
                )}`
            );
            await this.backToContractList();
        } catch (error) {
            this.makeToast(
                "danger",
                this.$t(
                    "modules.budget_execution_monitoring.editor_409.messages.del_err_msg"
                ),
                (error as Error).message
            );
        } finally {
            this.isAppSaving = false;
        }
    }

    private async saveExitForm() {
        const saved = await this.saveNewApp();

        if (saved) {
            await this.backToContractList();
        } else {
            this.showCloseModal = false;
        }
    }

    private resetAppForm() {
        this.appData = new AppDataClass();
        (this.$refs.appCard as any).resetForm();
        this.validationErrors = {};
    }

    private skipDateReload = false;

    private onMaxPayDateChanged(date: Date) {
        if (date > this.selectedDate) {
            this.skipDateReload = true;
            this.selectedDate = date;
        }
    }

    private async downloadInfo() {
        if (this.loading) {
            this.makeToast(
                "info",
                String(this.$t("modules.bank_projects.messages.attention_msg")),
                String(
                    this.$t("modules.bank_projects.messages.download_start_msg")
                )
            );
        } else {
            this.loading = true;
            const fileId = this.curLanguage === "kk" ? 55 : 54;
            await axios({
                method: "post",
                url: `/api-py/get-info/${fileId}`,
                responseType: "blob",
                data: null,
            })
                .then((response) => response.data)
                .then((data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    const titleOfFile =
                        this.curLanguage === "kk"
                            ? "4-09_редакторы_нұсқаулығы"
                            : "Инструкция_Редактор_4-09";

                    link.setAttribute("download", titleOfFile + ".pdf");
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((error) => {
                    console.log(error);
                    this.makeToast(
                        "danger",
                        String(
                            this.$t(
                                "modules.bank_projects.messages.user_guide_req_err_msg"
                            )
                        ),
                        error.toString()
                    );
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }

    makeToast(variant: string | undefined, tostbody: any, title: string) {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            toaster: "b-toaster-top-center",
            autoHideDelay: 4000,
            solid: true,
            appendToast: true,
        });
    }
}
